<template>
  <div
    class="eventComp_mode_17 eventComp_mode_container"
    v-show="currThemeObj && tableData"
  >
    <div class="tableGroup">
      <mergeHeadCel_tablel
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :tableMode="currModeName"
        :columnColorPropArr="columnColorPropArr_greyBg"
        :columnColorPropArr_otherBg="columnColorPropArr_whiteBg"
        :textAlignleftPropArr="textAlignleftPropArr"
        :tableColumnData="tableColumnData"
        :tableData="tableData"
        v-show="tableData && tableData.length > 0"
      ></mergeHeadCel_tablel>
    </div>
  </div>
</template>

<script>
// 适用： 射击（单人的本场数据等） 体操(跳马的单项成绩) 跆拳道（对抗类的本场数据） 合并单元格表格（头部合并单元格，row 运动员等信息合并单元格）
import mergeHeadCel_tablel from '@components/platfromBase/compreSportsMeet/table/mergeHeadCel_tablel.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_17',
  components: {
    mergeHeadCel_tablel,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
    competitorType: {
      type: String,
      default: '', // A || D || T
    },
    indexNo: {
      type: Number,
      default: null, // 0 || 1 ...
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_17 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      //   tableMode: 'eventComp_mode_17',
      currModeObj: null,
      currModeName: '',
      renderModeList: [
        {
          modeName: 'eventComp_mode_17_SHO',
          sportsIdArr: ['SHO'],
          //   tableColumnData: [
          //     {
          //       prop: 'ranking',
          //       id: 'ranking',
          //       label: '排名',
          //       widthVw: 5.55,
          //       // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
          //     },
          //     {
          //       prop: 'player_no',
          //       id: 'player_no',
          //       label: '号码',
          //       widthVw: 5.55,
          //       // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
          //     },
          //     {
          //       prop: 'playerName-playerLogo-playerGender-teamLogo-teamName',
          //       id: 'player_name',
          //       label: '运动员',
          //       //   widthVw: 25.42, //对应列的宽度，单位vw
          //       //   widthPx: Math.floor(25.42 * this.vw2px),
          //       className: 'columnTextLeftClass', //单独定制的头部样式class
          //       // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
          //     },
          //     {
          //       prop: '',
          //       id: 'totalGroup',
          //       label: '组',
          //       child: [
          //         {
          //           prop: '组-1',
          //           label: '1',
          //           widthVw: 3.75,
          //           className: 'columnHightBgClass',
          //         },
          //         {
          //           prop: '组-2',
          //           label: '2',
          //           widthVw: 3.75,
          //           className: 'columnHightBgClass',
          //         },
          //         {
          //           prop: '组-3',
          //           label: '3',
          //           widthVw: 3.75,
          //           className: 'columnHightBgClass',
          //         },
          //         {
          //           prop: '组-4',
          //           label: '4',
          //           widthVw: 3.75,
          //           className: 'columnHightBgClass',
          //         },
          //         {
          //           prop: '组-5',
          //           label: '5',
          //           widthVw: 3.75,
          //           className: 'columnHightBgClass',
          //         },
          //         {
          //           prop: '组-6',
          //           label: '6',
          //           widthVw: 3.75,
          //           className: 'columnHightBgClass',
          //         },
          //       ],
          //     },
          //     {
          //       prop: 'result',
          //       id: 'result',
          //       label: '成绩',
          //       widthVw: 5.55,
          //     },
          //     {
          //       prop: 'qualification_mark',
          //       id: 'qualification_mark',
          //       label: '备注',
          //       widthVw: 5.55,
          //     },
          //   ],
          //   columnColorPropArr_greyBg: ['组-1', '组-2', '组-3', '组-4', '组-5', '组-6'],
          textAlignleftPropArr: ['player_name'],
          mergKeyArrWidthVwArr: [3.75, 3.75], //[greyBg, whiteBg]
          tableCellDefaultWidthVw: 6.25,
          datasChildKey: '', //datas下需要的数据字段
        },
        {
          modeName: 'eventComp_mode_17_GAR',
          sportsIdArr: ['GAR'],
          textAlignleftPropArr: ['player_name'],
          mergKeyArrWidthVwArr: [4.16, 4.16],
          tableCellDefaultWidthVw: 6.25,
          datasChildKey: '', //datas下需要的数据字段
        },
        {
          modeName: 'eventComp_mode_17_TKW',
          sportsIdArr: ['TKW'],
          textAlignleftPropArr: ['player_name', 'desc'],
          mergKeyArrWidthVwArr: [5.55, 5.55],
          tableCellDefaultWidthVw: 5.55,
          datasChildKeyArr: ['result_score', 'result_desc'], //datas下需要的数据字段
        },
      ],
      tableData: null,
      tableColumnData: [],
      columnColorPropArr_greyBg: [],
      columnColorPropArr_whiteBg: [],
      textAlignleftPropArr: [],
    }
  },
  beforeCreate() {},
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      console.debug('mode_17:', this.datas)
      this.$nextTick(() => {
        // this.computedModeData({})
        if (this.currSportsDetail && this.currSportsDetail.sportsId) {
          this.renderModeList.forEach((modeItem) => {
            if (modeItem.sportsIdArr.includes(this.currSportsDetail.sportsId)) {
              this.currModeName = modeItem.modeName
              this.currModeObj = modeItem
              this.textAlignleftPropArr = modeItem.textAlignleftPropArr
              if (this.currSportsDetail.sportsId === 'TKW') {
                console.debug(this.indexNo)
                let datas = null
                let dynamicMergKeyArr = null
                if (this.indexNo === 0) {
                  let data = this.datas[modeItem.datasChildKeyArr[this.indexNo]]
                  datas = {
                    data: [data.home, data.away],
                    table_head: data.table_head,
                  }
                } else if (this.indexNo === 1) {
                  let data = this.datas[modeItem.datasChildKeyArr[this.indexNo]]
                  // dynamicMergKeyArr = [['摩洛哥'], ['日本']]
                  if (data.table_head.length >= 3) {
                    dynamicMergKeyArr = [
                      [data.table_head[1].name],
                      [data.table_head[2].name],
                    ]
                  }
                  datas = {
                    data: data.data,
                    table_head: data.table_head,
                  }
                }
                console.debug(datas, this.indexNo)

                this.computedModeData(
                  JSON.parse(JSON.stringify(datas)),
                  dynamicMergKeyArr
                )
              } else {
                this.computedModeData(JSON.parse(JSON.stringify(this.datas)))
              }
            }
          })
        }
      })
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    computedModeData(data, dynamicMergKeyArr) {
      console.debug('computedModeData:', data)
      if (data && data.data && data.table_head && data.table_head.length > 0) {
        let tableColumnData = []
        let mergKeyArr_greyBg = [
          '组',
          '立姿淘汰赛',
          '秒',
          '第二阶段',
          '第二跳',
          '回合',
        ]
        if (dynamicMergKeyArr && dynamicMergKeyArr.length > 0) {
          mergKeyArr_greyBg = [].concat(mergKeyArr_greyBg, dynamicMergKeyArr[0])
        }
        let columnColorPropArr_greyBg = []
        let mergKeyArr_whiteBg = ['第一阶段', '第一跳']
        if (dynamicMergKeyArr && dynamicMergKeyArr.length == 2) {
          mergKeyArr_whiteBg = [].concat(
            mergKeyArr_whiteBg,
            dynamicMergKeyArr[1]
          )
        }
        let columnColorPropArr_whiteBg = []

        let widthVw = this.currModeObj.tableCellDefaultWidthVw

        data.table_head.forEach((column) => {
          if (column.map_key_arr.length === 1) {
            let prop = column.map_key_arr[0]
            if (
              this.indexNo === 1 &&
              this.currSportsDetail.sportsId === 'TKW' &&
              column.name === '描述'
            ) {
              tableColumnData.push({
                prop: prop,
                id: prop,
                label: column.name,
                //   widthVw: 25.42, //对应列的宽度，单位vw
                //   widthPx: Math.floor(25.42 * this.vw2px),
                className: 'columnTeamLogoTeamNameClass', //单独定制的头部样式class
                // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
              })
            } else {
              tableColumnData.push({
                prop: prop,
                id: prop,
                label: column.name,
                widthVw,
              })
            }
          }
          if (column.name === '运动员') {
            tableColumnData.push({
              prop: 'playerName-playerLogo-playerGender-teamLogo-teamName',
              id: 'player_name',
              label: column.name,
              //   widthVw: 25.42, //对应列的宽度，单位vw
              //   widthPx: Math.floor(25.42 * this.vw2px),
              className: 'columnPlayerGroupClass', //单独定制的头部样式class
              // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
            })
          }
          if (column.name === '国家/地区') {
            tableColumnData.push({
              prop: 'teamLogo-teamName',
              id: 'player_name',
              label: column.name,
              //   widthVw: 25.42, //对应列的宽度，单位vw
              //   widthPx: Math.floor(25.42 * this.vw2px),
              className: 'columnTeamLogoTeamNameClass', //单独定制的头部样式class
              // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
            })
          }
          if (mergKeyArr_greyBg.includes(column.name)) {
            columnColorPropArr_greyBg = [].concat(
              columnColorPropArr_greyBg,
              column.map_key_arr
            )
            let child = column.map_key_arr.map((rowCeil) => {
              return {
                prop: rowCeil,
                label: rowCeil.split('-')[1],
                widthVw: this.currModeObj.mergKeyArrWidthVwArr[0],
                className: 'columnHightBgClass',
              }
            })
            tableColumnData.push({
              prop: '',
              id: `totalGroup_${mergKeyArr_greyBg.indexOf(column.name)}`,
              label: column.name,
              child,
            })
          }

          if (mergKeyArr_whiteBg.includes(column.name)) {
            columnColorPropArr_whiteBg = [].concat(
              columnColorPropArr_whiteBg,
              column.map_key_arr
            )
            let child = column.map_key_arr.map((rowCeil) => {
              return {
                prop: rowCeil,
                label: rowCeil.split('-')[1],
                widthVw: this.currModeObj.mergKeyArrWidthVwArr[1],
                className: '',
              }
            })
            tableColumnData.push({
              prop: '',
              id: `totalGroup_${mergKeyArr_whiteBg.indexOf(column.name)}`,
              label: column.name,
              child,
            })
          }
        })
        this.columnColorPropArr_greyBg = columnColorPropArr_greyBg
        this.columnColorPropArr_whiteBg = columnColorPropArr_whiteBg

        this.tableColumnData = tableColumnData
        console.debug('tableColumnData:', tableColumnData)

        let tableData = data.data.map((rowData) => {
          this.tableColumnData.forEach((columnItem) => {
            if (columnItem.widthVw) {
              columnItem.widthPx = Math.floor(columnItem.widthVw * this.vw2px)
            }

            if (columnItem.child) {
              columnItem.child.forEach((childItem) => {
                if (childItem.widthVw) {
                  childItem.widthPx = Math.floor(childItem.widthVw * this.vw2px)
                }
                if (columnItem.isAssignFlag) {
                  console.debug('columnItem:', columnItem)
                  if (childItem.originVal.length > 1) {
                    let originValArr = []
                    childItem.originVal.forEach((originItem) => {
                      originValArr.push(rowData[originItem])
                    })
                    rowData[childItem.prop] = originValArr.join('/')
                  } else {
                    rowData[childItem.prop] = rowData[childItem.originVal[0]]
                  }
                }
              })
            } else {
              if (columnItem.isAssignFlag) {
                rowData[columnItem.prop] = rowData[columnItem.originVal[0]]
              }
            }
          })
          console.debug(rowData)
          if (rowData.is_win === false) {
            rowData.is_win = '负'
          }
          if (rowData.is_win === true) {
            rowData.is_win = '胜'
          }
          // this.columnColorPropArr_greyBg.forEach
          return rowData
        })
        console.debug('this.tableData:', tableData)
        this.tableData = tableData
      } else {
        console.debug('暂无数据')
        this.notDataHandler()
      }
    },
    notDataHandler() {
      this.totalData = 0
      this.tableData = []
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  padding: 1.388vw 0;
  .tableGroup {
    position: relative;
    width: 100%;
    padding-bottom: 1.388vw;
  }
}
</style>
